module.exports = __webpack_public_path__ + "static/media/DSCF9011.7c261e35.JPG";